import { useNavigate } from "react-router-dom";
import {
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Box,
    Typography,
    Button,
    IconButton,
} from "@mui/material";
import { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import SearchBar from "../../../components/SearchBar";
import MainContainer from "../../../layout/MainContainer";
import AddPrompt from "../../../Modals/addPrompt";

const SmartMessaging = () => {
    const navigate = useNavigate();

    const [rows] = useState([
        {
            id: 1,
            language: "Arabic",
            prompt: "Write an apology email in Arabic",
        },
        {
            id: 2,
            language: "French",
            prompt: "Draft romantic note in French",
        },
    ]);


    const [open, setOpen] = useState(false);

    const handleCloseModal = () => {
        setOpen(false);
    }
    const [searchTerm, setSearchTerm] = useState("");


    return (
        <><>
            <div className="main_title">
                <h1>Smart Messaging</h1>
                <p>
                    <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Smart Messaging
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search..." />
                        </Box>
                    </div>
                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpen(true)}><AddIcon /> Add Prompt </Button>
                    </div>
                </div>
                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow hover>
                                <TableCell>Language</TableCell>
                                <TableCell>Prompt</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[
                                { id: 1, language: "Arabic", prompt: "Write an apology email in Arabic" },
                                { id: 2, language: "French", prompt: "Draft romantic note in French" },
                            ].map((row) => (
                                <TableRow hover key={row.id}>
                                    <TableCell>
                                        <Typography fontWeight="bold">{row.language}</Typography>
                                    </TableCell>
                                    <TableCell>{row.prompt}</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton onClick={() => setOpen(true)}>
                                                    <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                </IconButton>
                                            </Box>
                                            <Box>
                                                <IconButton onClick={() => console.log("Delete prompt")}>
                                                    <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>


            </div>
        </><AddPrompt open={open} onClose={handleCloseModal} setOpen={setOpen} /></>
    );
};

export default SmartMessaging;
